window.initStickyProductBlock = function () {
  const stickyBlock = document.getElementById("sticky-product-block");

  if (stickyBlock) {
    const isMobile = window.innerWidth <= 768;
    const headerMainHeight = document.querySelector("#header-main-wrapper")?.offsetHeight || 0;
    const headerNavHeight = document.querySelector(".c-header-nav")?.offsetHeight || 0;
    const filterGroupHeight = window.filter_group_height || 0; // Make sure this variable is globally set
    const headerGroupHeight = window.header_group_height || 0;

    const topOffset = isMobile
      ? headerMainHeight + headerNavHeight
      : headerNavHeight || (filterGroupHeight || headerGroupHeight);

    stickyBlock.style.top = `${topOffset}px`;
  }
};
